import React from 'react';
import classnames from 'classnames';
import { history } from 'umi';
import COSDocPreviewer, { NavigatorToolbar } from '@gp/components/COSDocPreviewer';
import CommonNoAuthPageAccess from './CommonNoAuthPageAccess';
import { queryPageAuthority, getBIDSTencentQCouldMassage } from '@gp/services/global';
// @ts-ignore
import { storage } from '@gp/utils/utils';
import { PROJECT_DETAIL_STORAGE_KEY } from '@gp/constants/storageKeys';
import { ENV } from '@home/_config/config';
import type { IBaseProps } from '@home/types/common';
import { UPLOAD_FOLDER_NAME_MAP } from '@gp/constants/const';

interface IMilestoneDocPreviewerProps extends IBaseProps {
  project_id: string;
  project: string;
  // 预览文档归属的milestone的id
  milestone_id: string;
  // 预览文档的cos的存储的key，需要用这个key去cos生成文档的预览链接
  doc_key: string;
}

// 获取权限数据，是否有查看milestone materials的权限
const getAuth = async (params: { project_id: string; }): Promise<boolean> => {
  const { project_id: projectId } = params || {};
  const res = await queryPageAuthority({
    assort: 'game_detail_info',
    project_id: projectId,
  });
  return !!res?.milestone_material;
};

const MilestoneDocPreviewer: React.FC<IMilestoneDocPreviewerProps> = (props) => {
  const {
    style,
    className,
    project_id: projectId,
    project,
    milestone_id: milestoneId,
    doc_key: docKey,
    doc_name: docName,
    doc_suffix: docSuffix,
  } = props;

  const handleNavigatorClick = () => {
    const filter = {
      projectId,
      project,
      tab: 'milestone',
      menuFrom: '111',
    };
    const filterStr = encodeURIComponent(JSON.stringify(filter));
    storage.setSessionStorageItem(PROJECT_DETAIL_STORAGE_KEY.GPOP_CACHE_MILESTONE_ID_STORAGE_KEY, milestoneId);
    history.replace(`/g-pop/Pipeline/ProjectList/Detail?filter=${filterStr}`);
  };

  // 全球加速，预发布和正式
  const controlledEnv = ['pre', 'pro'];
  const isUseAccelerate = controlledEnv.includes(ENV);
  const uploadFolderName = UPLOAD_FOLDER_NAME_MAP.milestoneReview;
  // const uploadFolderName = docKey?.includes('/') ? docKey.split('/')[0] : '';

  return (
    <div style={style} className={classnames('dbg-milestone-doc-previewer', className)}>
      <COSDocPreviewer
        docKey={docKey}
        docName={docName}
        docSuffix={docSuffix}
        cosOptions={{
          useAccelerate: isUseAccelerate,
          baseCOSConfigFetcher: () => getBIDSTencentQCouldMassage(uploadFolderName),
          authorizationFetcher: (_options?: any) => getBIDSTencentQCouldMassage(uploadFolderName),
        }}
        getAuthParams={{ project_id: projectId }}
        getAuth={getAuth}
        toolbar={<NavigatorToolbar title="To Project Milestone" onNavigatorClick={handleNavigatorClick} />}
        noAuth={<CommonNoAuthPageAccess />}
      />
    </div>
  );
};

export default MilestoneDocPreviewer;
